/* qty-shake-global.js - single initialiser for quantity max feedback on PDP, cart drawer, cart and product cards. */
(function () {
  if (window.__mcQtyShakeLoaded) return;
  window.__mcQtyShakeLoaded = true;

  var ROOT_SELECTOR = '.quantity';
  var INPUT_SELECTOR = '.quantity__input';
  var PLUS_SELECTOR = '.quantity__button[name="plus"], button[name="plus"]';
  var SCAN_DEBOUNCE = 80;
  var scanTimer = null;

  function toInt(value) {
    var number = parseInt(value, 10);
    return Number.isFinite(number) ? number : 0;
  }

  function getInput(scope) {
    return scope && scope.querySelector ? scope.querySelector(INPUT_SELECTOR) : null;
  }

  function getMax(input) {
    if (!input) return null;
    var raw = input.getAttribute('max') || input.dataset.max || '';
    if (raw === '') return null;
    var max = parseInt(raw, 10);
    return Number.isFinite(max) && max > 0 ? max : null;
  }

  function markShake(quantity) {
    if (!quantity) return;
    quantity.classList.remove('is-shaking');
    void quantity.offsetWidth;
    quantity.classList.add('is-shaking');
    window.setTimeout(function () {
      quantity.classList.remove('is-shaking');
    }, 360);
  }

  function setState(input, bumpIfMax) {
    if (!input) return;
    var quantity = input.closest(ROOT_SELECTOR);
    if (!quantity) return;
    var max = getMax(input);
    var value = toInt(input.value || input.getAttribute('value') || '0');
    var atMax = max !== null && value >= max;

    quantity.classList.toggle('quantity--max', atMax);
    var plus = quantity.querySelector(PLUS_SELECTOR);
    if (plus) {
      plus.classList.toggle('quantity__button--max', atMax);
      if (atMax) plus.setAttribute('aria-disabled', 'true');
      else plus.removeAttribute('aria-disabled');
    }
    if (bumpIfMax && atMax) markShake(quantity);
  }

  function scan(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll(INPUT_SELECTOR).forEach(function (input) {
      setState(input, false);
    });
  }

  function scheduleScan(root) {
    window.clearTimeout(scanTimer);
    scanTimer = window.setTimeout(function () {
      scan(root || document);
    }, SCAN_DEBOUNCE);
  }

  document.addEventListener('input', function (event) {
    if (event.target && event.target.matches && event.target.matches(INPUT_SELECTOR)) {
      setState(event.target, false);
    }
  }, true);

  document.addEventListener('change', function (event) {
    if (event.target && event.target.matches && event.target.matches(INPUT_SELECTOR)) {
      setState(event.target, false);
    }
  }, true);

  document.addEventListener('click', function (event) {
    var button = event.target && event.target.closest ? event.target.closest(PLUS_SELECTOR + ', .quantity__button[name="minus"], button[name="minus"]') : null;
    if (!button) return;
    var quantity = button.closest(ROOT_SELECTOR);
    var input = getInput(quantity);
    if (!input) return;
    window.setTimeout(function () {
      setState(input, button.matches(PLUS_SELECTOR));
    }, 0);
  }, true);

  document.addEventListener('cart:updated', function () { scheduleScan(document); });
  document.addEventListener('variant:change', function () { scheduleScan(document); });
  document.addEventListener('shopify:section:load', function (event) { scheduleScan(event.target || document); });

  if ('MutationObserver' in window) {
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i += 1) {
        if (mutations[i].addedNodes && mutations[i].addedNodes.length) {
          scheduleScan(document);
          break;
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(document); });
  } else {
    scan(document);
  }
})();
